const isHomePage = document
    .querySelector("body")
    .classList.contains("template-index");

const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

(function initReducedMotion() {
    if (prefersReducedMotion) {
        // Disable autoplay for all videos and pause videos already playing
        const videos = document.querySelectorAll('video[autoplay]');
        videos.forEach(video => {
            if (!video.paused) video.pause();
            video.removeAttribute('autoplay');
        })
    }
})();

// Announcement Bar
(function initAnnouncementBar() {
    const list = document.querySelector('.announcement-bar-slides');

    // Do not animate announcement bar
    if (prefersReducedMotion) {
        list.classList.add('_has-reduced-motion')
        return;
    }

    const slides = list.children;
    const total = slides.length;

    if (total < 2) {
        return;
    }

    let index = 0;

    function showSlide(i) {
        index = (i + total) % total;
        list.style.transform = `translateX(-${index * 100}%)`;
    }

    setInterval(() => showSlide(index + 1), 3000);
})();

// Quick Shop
(function InitQuickShop() {
    document.querySelectorAll('.quick-shop-qty').forEach((quickShop) => {
        quickShop.querySelectorAll('button').forEach((button) => {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                window.addToCart(quickShop.getAttribute('data-variantid'), button.innerText);
            })
        });
    });
})();



// Cart Drawer
(function InitCartDrawer() {
    const cartDrawer = document.querySelector("#cart-drawer");
    const cartDrawerContents = cartDrawer.querySelector(".cart-drawer-contents");
    const cartOverlay = cartDrawer.parentElement;
    const cartToggles = document.querySelectorAll('[aria-controls="cart-overlay"]');

    
    const refreshCartProgress = (amount) => {
        if (!amount) amount = 0;
        
        // gather infos
        const amounts = window.cartProgressAmounts || [];
        amounts.sort((a, b) => a - b);
        
        const highestAmount = amounts.length > 0 ? amounts[amounts.length - 1] : undefined;
        const lowestAmount = amounts.length > 0 ? amounts[0] : undefined;
        
        const wrapperEl = document.getElementById('cart-progress');
        const fillbarEl = document.getElementById('cart-progress-fill');
        
        // check for relevant elements
        if (!wrapperEl) {
            console.error('Cart progress wrapper not found');
            return;
        }
        
        if (amounts.length === 0) {
            console.error('No amounts found');
            wrapperEl.style.display = 'none';
            return;
        }
        
        // calculate the overall progress
        let progressPercent = amount / highestAmount * 100
        if (progressPercent >= 100) {
           progressPercent = 100; 
        }
        // update the fillbar
        fillbarEl.style.width = `${progressPercent}%`;
        
        // loop through all ammounts and calculate the position for each step
        amounts.forEach((thisAmount, index) => {
            const dotEl = document.getElementById(`cart-progress-dot-${index + 1}`);
            const labelEl = document.getElementById(`cart-progress-label-${index + 1}`);
            const progressPercent = thisAmount / highestAmount * 100;
            dotEl.style.left = `${progressPercent}%`;
            labelEl.style.left = `${progressPercent}%`;
            labelEl.style.display = 'flex';
            // set the last label to translateX(-100%)
            if (index === amounts.length - 1) {
                labelEl.style.transform = 'translateX(-100%)';
                labelEl.style.textAlign = 'right';
            }
        });
        
        
        // show messages depending on the amount
        
        // Hide all elements with class 'cart-drawer-progress-text'
        document.querySelectorAll('.cart-drawer-progress-text').forEach((el) => {
            el.style.display = 'none';
        });
        
        // if amount is lower then the lowest amount, show the lowest message
        if (amount < lowestAmount) {
            const firstMessageEl = document.getElementById('cart-progress-message-1');
            firstMessageEl.style.display = 'flex';
            return;
        }
        
        // if amount is greater then the maximum amount, show the finished message
        if (amount >= highestAmount) {
            const finishedMessageEl = document.getElementById('cart-progress-message-finished');
            finishedMessageEl.style.display = 'flex';
            return;
        }
        
        // now show the in between message
        if (amounts.length === 2) {
            if (amount >= amounts[0]) {
                const secondMessageEl = document.getElementById('cart-progress-message-2');
                secondMessageEl.style.display = 'flex';
                return;
            }
        }
        if (amounts.length === 3) {
            if (amount >= amounts[1]) {
                const thirdMessageEl = document.getElementById('cart-progress-message-3');
                thirdMessageEl.style.display = 'flex';
                return;
            } else {
                const secondMessageEl = document.getElementById('cart-progress-message-2');
                secondMessageEl.style.display = 'flex';
                return;
            }
        }
        
        return;
        
    };

    const onCartChange = (cart) => {
        // console.log('onCartChange', cart)
        const totalPrice = cart.total_price || 0;
        window.cartTotalPrice = totalPrice;
        refreshCartProgress(totalPrice);
    };

    
    const initQuantitySelector = (selector) => {
        const display = selector.querySelector(".cart-drawer-amount");

        selector
            .querySelectorAll(".cart-drawer-minus, .cart-drawer-plus")
            .forEach((button) => {
                const handleChangeQuantity = () => {
                    let value = parseInt(display.innerText.trim());

                    if (button.classList.contains("cart-drawer-minus")) {
                        value = value < 1 ? 0 : value - 1;
                    } else {
                        value = value + 1;
                    }

                    display.innerText = value;

                    fetch("/cart/change.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            id: selector.getAttribute("data-key"),
                            quantity: value,
                        }),
                    })
                        .then((res) => res.json())
                        .then((cart) => {
                            renderItems();
                            // Dispatch cart change event
                            document.dispatchEvent(new CustomEvent('cart:change', {
                                detail: { cart: cart }
                            }));
                            // Dispatch item updated event
                            document.dispatchEvent(new CustomEvent('cart:item-updated', {
                                detail: { cart: cart, item: cart.items.find(item => item.key === selector.getAttribute("data-key")) }
                            }));
                        })
                        .catch((err) => {
                            alert("Error updating cart");
                            console.log(error);
                        });
                }

                button.addEventListener('keydown', (e) => {
                    if(e.key === 'Enter') {
                        handleChangeQuantity();
                    }
                })
                button.addEventListener("click", () => {
                    handleChangeQuantity();
                });
            });
    };

    const renderItems = () => {
        fetch("/cart.js")
            .then((response) => response.json())
            .then((data) => {
                const lineItems = [];
                const lineItem = `
				<article>
                    <img src="[CART_ITEM_IMAGE]" alt="" />
					<div class="cart-drawer-details">
						<div class="cart-drawer-main">
							<a href="[CART_ITEM_URL]" class="cart-drawer-title">
								[CART_ITEM_TITLE]
							</a>
							<div class="cart-drawer-combo"><!--metafields--></div>
						</div>
						<div class="cart-drawer-money">
							<div>[CART_ITEM_PRICE] €</div>
							<span class="cart-drawer-selector" data-key="[CART_ITEM_KEY]">
								<span class="cart-drawer-minus" role="button" tabindex="0"></span>
								<span class="cart-drawer-amount">[CART_ITEM_QTY]</span>
								<span class="cart-drawer-plus" role="button" tabindex="0"></span>
							</span>
						</div>
					</div>
				</article>`;

                data.items.forEach((item) => {
                    // data is added to the cartMetafieldsData object in the theme.liquid file
                    const itemMetafields =
                        window.cartMetafieldsData && window.cartMetafieldsData[item.id]
                            ? window.cartMetafieldsData[item.id]
                            : {};
                    let itemStuckpreis = null;
                    let itemGrundpreis = null;
                    let metafields = "";
                    if (itemMetafields.product_stuckpreis) {
                        itemStuckpreis = itemMetafields.product_stuckpreis;
                    }
                    if (itemMetafields.produkt_grundpreis) {
                        itemGrundpreis = itemMetafields.produkt_grundpreis;
                    }

                    if (itemStuckpreis) {
                        metafields = `
							${itemStuckpreis}
							<br/>
						`;
                    }
                    if (itemGrundpreis) {
                        metafields += `
							${itemGrundpreis}
							<br/>
						`;
                    }
                    lineItems.push(
                        lineItem
                            .replace("[CART_ITEM_KEY]", item.key)
                            .replace(
                                "[CART_ITEM_PRICE]",
                                (item.final_line_price / 100).toLocaleString("de-DE", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })
                            )
                            .replace("[CART_ITEM_IMAGE]", item.image)
                            .replace("[CART_ITEM_TITLE]", item.product_title)
                            .replace("[CART_ITEM_QTY]", item.quantity)
                            .replace("<!--metafields-->", metafields)
                            .replaceAll("[CART_ITEM_URL]", item.url)
                    );
                });

                document.querySelector(
                    ".cart-trigger sup"
                ).innerText = `(${data.item_count})`;
                cartDrawer.querySelector(
                    "header sup"
                ).innerText = `(${data.item_count})`;

                if (lineItems.length) {
                    cartDrawer.querySelector(".cart-drawer-value").innerText = `${(
                        data.total_price / 100
                    ).toLocaleString("de-DE", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })} €`;
                    cartDrawerContents.innerHTML = lineItems.join("");
                    cartDrawerContents
                        .querySelectorAll(".cart-drawer-selector")
                        .forEach((selector) => {
                            initQuantitySelector(selector);
                        });
                    cartOverlay.querySelector("footer").removeAttribute("style");
                } else {
                    cartDrawerContents.innerHTML =
                        '<div class="cart-drawer-empty">Ihr Warenkorb ist im Moment leer.</div>';
                    cartOverlay.querySelector("footer").style.display = "none";
                }
            })
            .catch((error) => {
                alert("Error fetching cart");
                console.log(error);
            });
    };

    const openCart = () => {
        // Dispatch before open event
        document.dispatchEvent(new CustomEvent('on:cart-drawer:before-open'));
        
        cartOverlay.querySelector("footer").style.display = "none";
        cartDrawerContents.innerHTML = "";

        cartOverlay.classList.add("is-active");
        cartOverlay.hidden = false;

        // Set focus within cart overlay
        cartOverlay.querySelector('[aria-controls="cart-overlay"]').focus();

        // Trap focus
        const focusableElements = cartOverlay.querySelectorAll( 'a, button, [role="button"], input');
        const firstFocusableElement = focusableElements[0];
        const lastFocusableElement = focusableElements[focusableElements.length - 1];

        firstFocusableElement.addEventListener('keydown', (e) => {
            if (e.code === "Tab" && e.shiftKey) {
                e.preventDefault();
                lastFocusableElement.focus();
            }
        });

        lastFocusableElement.addEventListener('keydown', (e) => {
            if (e.code === "Tab" && !e.shiftKey) {
                e.preventDefault();
                firstFocusableElement.focus();
            }
        });

        renderItems();
        
        // Dispatch after open event
        setTimeout(() => {
            document.dispatchEvent(new CustomEvent('on:cart-drawer:after-open'));
        }, 100);
    };

    const closeCart = () => {
        // Dispatch before close event
        document.dispatchEvent(new CustomEvent('on:cart-drawer:before-close'));
        
        cartOverlay.hidden = true;
        cartOverlay.classList.remove("is-active");

        // Re-set focus to cart trigger
        document.querySelector('.cart-trigger').focus();
        
        // Dispatch after close event
        setTimeout(() => {
            document.dispatchEvent(new CustomEvent('on:cart-drawer:after-close'));
        }, 100);
    }

    const toggleCart = () => {
        if (cartOverlay.hidden) {
            openCart();
        } else {
            closeCart();
        }
    }

    window.addToCart = (variantId, quantity = 1) => {
        openCart();

        // Get the selected quantity from the hidden input
        const selectedQuantity = document.getElementById("selected-quantity")
            ? parseInt(document.getElementById("selected-quantity").value)
            : quantity;

        fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            body: JSON.stringify({
                id: variantId,
                quantity: selectedQuantity,
            }),
        })
            .then((res) => res.json())
            .then((item) => {
                renderItems();
                // Dispatch cart change event
                document.dispatchEvent(new CustomEvent('cart:change', {
                    detail: { cart: item }
                }));
                // Dispatch item added event
                document.dispatchEvent(new CustomEvent('cart:item-added', {
                    detail: { item: item }
                }));
            })
            .catch((error) => {
                alert("Error adding to cart");
                console.log(error);
            });
    };

    cartToggles.forEach(toggle => {
        toggle.addEventListener("click", toggleCart);
    })

    cartDrawer.addEventListener("keydown", (e) => {
        if (e.key === 'Escape') {
            closeCart();
        }
    });

    // Shopify Cart Events
    document.addEventListener('cart:change', function(event) {
        onCartChange(event.detail.cart);
    });

    document.addEventListener('cart:item-added', function(event) {
        // event also triggered cart:change
        // console.log('cart:item-added', event.detail);
        onCartChange({total_price: event.detail.item.final_line_price});
    });

    document.addEventListener('cart:item-removed', function(event) {
        // event also triggered cart:change
        // onCartChange(event.detail.cart);
    });

    document.addEventListener('cart:item-updated', function(event) {
        // event also triggered cart:change
        // onCartChange(event.detail.cart);
    });

    // Cart drawer events
    document.addEventListener('on:cart-drawer:before-open', function(event) {
        // console.log('Cart drawer opening...');
        refreshCartProgress(window.cartTotalPrice);
    });

    document.addEventListener('on:cart-drawer:after-open', function(event) {
        // console.log('Cart drawer opened', event);
    });

    document.addEventListener('on:cart-drawer:before-close', function(event) {
        // console.log('Cart drawer closing...');
    });

    document.addEventListener('on:cart-drawer:after-close', function(event) {
        // console.log('Cart drawer closed');
    });
})();

// Mobile Menu
(function InitMobileMenu() {
    document
        .querySelector(".mobile-menu-trigger")
        .addEventListener("click", (event) => {
            document.querySelector(".mobile-menu").classList.toggle("is-active");
            document
                .querySelector(".mobile-menu-trigger")
                .classList.toggle("is-active");
        });
})();

// Header
(function InitHeader() {
    const header = document.getElementById("header");
    let lastScrollTop = 0;

    window.addEventListener("scroll", () => {
        let currentScroll = window.scrollY || document.documentElement.scrollTop;

        if (currentScroll > lastScrollTop) {
            header.classList.add("is-down-scroll");
            header.classList.remove("is-up-scroll");
        } else if (currentScroll < lastScrollTop) {
            header.classList.add("is-up-scroll");
            header.classList.remove("is-down-scroll");
        }

        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;

        const banneHeight = document.querySelector(".page-banner")
            ? document.querySelector(".page-banner").offsetHeight
            : window.innerHeight;

        if (isHomePage) {
            if (window.scrollY >= banneHeight - 149) {
                header.classList.add("is-shrinked");
            } else {
                header.classList.remove("is-shrinked");
            }
        }

        // if (window.scrollY >= banneHeight - 117) {
        if (window.scrollY >= banneHeight / 2) {
            header.classList.add("is-hidden");
        } else {
            header.classList.remove("is-hidden");
        }

        if (window.scrollY >= banneHeight) {
            header.classList.add("is-filled");
        } else {
            header.classList.remove("is-filled");
        }
    });
})();

// Hero Banner
(function InitHeroBanner() {
    const heroBanner = document.querySelector(".hero-banner.is-carousel");

    if (heroBanner) {
        const prevButton = heroBanner.querySelector(".hero-banner-prev");
        const nextButton = heroBanner.querySelector(".hero-banner-next");

        // Select both video and img elements to handle all media types
        const mediaDesktop = heroBanner.querySelectorAll(".mobile-hidden video, .mobile-hidden img");
        const mediaMobile = heroBanner.querySelectorAll(".mobile-only video, .mobile-only img");
        const textBoxes = heroBanner.querySelectorAll(".hero-banner-holder");
        const slides = heroBanner.querySelector(".hero-banner-status");

        slides.classList.add("is-animation-1-ready");

        setTimeout(() => {
            slides.classList.add("is-animating-1-now");
        }, 150);

        const slideAction = (activeIndex, nextActiveIndex) => {
            // Ensure nextActiveIndex is valid
            if (nextActiveIndex < 0 || nextActiveIndex >= mediaDesktop.length) {
                return;
            }

            // Remove active state from previous slide if it exists
            if (activeIndex !== -1 && activeIndex < mediaDesktop.length) {
                mediaDesktop[activeIndex].classList.remove("is-active");
                mediaMobile[activeIndex].classList.remove("is-active");
                textBoxes[activeIndex].classList.remove("is-active");

                textBoxes[activeIndex]
                    .querySelector(".hero-banner-text")
                    .classList.remove("is-animated");
                textBoxes[activeIndex]
                    .querySelector(".hero-banner-text")
                    .classList.remove("is-active-second");
            }

            // Add active state to next slide
            mediaDesktop[nextActiveIndex].classList.add("is-active");
            mediaMobile[nextActiveIndex].classList.add("is-active");
            textBoxes[nextActiveIndex].classList.add("is-active");
                textBoxes[nextActiveIndex]
                    .querySelector(".hero-banner-text")
                    .classList.add("is-animated");

                slides.className = "hero-banner-status";

                setTimeout(() => {
                    slides.className = `hero-banner-status is-animation-${
                        nextActiveIndex + 1
                    }-ready is-active-${nextActiveIndex + 1}`;
                    textBoxes[nextActiveIndex]
                        .querySelector(".hero-banner-text")
                        .classList.add("is-active");
                }, 200);

                setTimeout(() => {
                    slides.classList.add(`is-animating-${nextActiveIndex + 1}-now`);
                    textBoxes[nextActiveIndex]
                        .querySelector(".hero-banner-text")
                        .classList.add("is-active");
                }, 400);

                setTimeout(() => {
                    textBoxes[nextActiveIndex]
                        .querySelector(".hero-banner-text")
                        .classList.add("is-active-second");
                }, 600);
        };

        prevButton.addEventListener("click", () => {
            clearInterval(window.heroBannerIntervalId);
            let activeIndex = Array.from(mediaDesktop).findIndex((media) =>
                media.classList.contains("is-active")
            );
            // If no active element found, default to 0
            if (activeIndex === -1) {
                activeIndex = 0;
            }
            const nextActiveIndex =
                activeIndex === 0 ? mediaDesktop.length - 1 : activeIndex - 1;
            slideAction(activeIndex, nextActiveIndex);
        });

        nextButton.addEventListener("click", () => {
            clearInterval(window.heroBannerIntervalId);
            let activeIndex = Array.from(mediaDesktop).findIndex((media) =>
                media.classList.contains("is-active")
            );
            // If no active element found, default to 0
            if (activeIndex === -1) {
                activeIndex = 0;
            }
            const nextActiveIndex =
                activeIndex === mediaDesktop.length - 1 ? 0 : activeIndex + 1;
            slideAction(activeIndex, nextActiveIndex);
        });

        setTimeout(() => {
            slides.classList.add("is-active-1");

            // Do not skip to next slide
            if (prefersReducedMotion) {
                return;
            }

            window.heroBannerIntervalId = setInterval(() => {
                let activeIndex = Array.from(mediaDesktop).findIndex((media) =>
                    media.classList.contains("is-active")
                );
                // If no active element found, default to 0
                if (activeIndex === -1) {
                    activeIndex = 0;
                }
                const nextActiveIndex =
                    activeIndex === mediaDesktop.length - 1 ? 0 : activeIndex + 1;
                slideAction(activeIndex, nextActiveIndex);
            }, 6000);
        });
    }
})();

// Featured Products
(function InitFeaturedProducts() {
    const element = document.querySelector(".featured-topic-subtitle ul");

    if (element) {
        const items = element.querySelectorAll("li");
        let currentIndex = 0;

        setInterval(() => {
            items[currentIndex].classList.remove("is-active");
            currentIndex = (currentIndex + 1) % items.length;
            items[currentIndex].classList.add("is-active");
        }, 3000);
    }
})();

// Best Choice
(function InitBestChoice() {
    const section = document.querySelector(".best-choice");

    if (section) {
        const lis = section.querySelectorAll("li");
        const targets = section.querySelectorAll(".best-choice-product");

        lis.forEach((li, index) => {
            li.addEventListener("click", () => {
                lis.forEach((li2) => {
                    li2.classList.remove("is-active");
                });

                targets.forEach((target) => {
                    target.classList.remove("is-active");
                    target.classList.remove("in-animation");
                });

                li.classList.add("is-active");
                targets[index].classList.add("is-active");

                setTimeout(() => {
                    targets[index].classList.add("is-animated");

                    setTimeout(() => {
                        targets[index].classList.add("in-animation");

                        setTimeout(() => {
                            targets[index].classList.remove("is-animated");
                        }, 500);
                    }, 150);
                }, 150);
            });
        });
    }
})();

// Big Quote
(function InitBigQuote() {
    const element = document.querySelector(".big-quote-text");

    if (element) {
        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];

                if (entry.isIntersecting) {
                    element.classList.add("is-active");
                } else {
                    element.classList.remove("is-active");
                }
            },
            {
                threshold: 0.5,
            }
        );

        observer.observe(element);
    }
})();

// PDP Buy Bar
(function InitBuyBar() {
    const bar = document.querySelector(".pdp-buy");

    if (bar) {
        window.addEventListener("scroll", function () {
            if (window.scrollY > 0) {
                bar.classList.add("is-scrolled");
            } else {
                bar.classList.remove("is-scrolled");
            }
        });
    }
})();

// PDP Tabs
(function InitPdpTabs() {
    const tabs = document.querySelector(".pdp-tabs");

    if (tabs) {
        tabs.querySelectorAll(".pdp-tab-title").forEach((tab) => {
            tab.addEventListener("click", () => {
                tab.parentElement.classList.toggle("is-active");
            });
        });
    }
})();

// PDP Quantity Selector
(function InitPdpQuantitySelector() {
    const selector = document.querySelector(".pdp-buy-qty");

    if (selector) {
        const dropdown = selector.querySelector(".qty-selector");
        const selection = selector.querySelector(".qty-selection");
        
        const openSelector = () => {
            dropdown.classList.add("is-active");
            selection.classList.add("is-active");
            selection.setAttribute('aria-expanded', 'true');
        }

        const closeSelector = () => {
            dropdown.classList.remove("is-active");
            selection.classList.remove("is-active");
            selection.setAttribute('aria-expanded', 'false');
        }

        const setSelectorOption = (option) => {
            const isVariantSelector = option.getAttribute('data-variant-selector') === 'true';
            document.querySelector(".final-price").innerText = option.getAttribute("data-price");
            selection.querySelector(".qty-selection-text").innerHTML = option.querySelector(".qty-selector-text").innerHTML;

            if (isVariantSelector) {
                const variantId = option.getAttribute('data-value');
                
                // Update the image
                // document.querySelector(".pdp-banner-image").src = option.getAttribute('data-variant-image');
                // update the hidden variant input
                // document.getElementById("selected-variant").value = variantId;
                // update the variant query parameter with the id in data-value
                
                const url = new URL(window.location.href);
                url.searchParams.set('variant', variantId);
                window.location.href = url.toString();
            } else {
                // Update the hidden quantity input
                document.getElementById("selected-quantity").value = option.getAttribute("data-value");
            }
            // Update aria-activedescendant
            dropdown.setAttribute('aria-activedescendant', option.id);
        }

        selection.addEventListener("click", () => {
            const open = selection.getAttribute('aria-expanded') === 'true';
            dropdown.classList.toggle("is-active");
            selection.classList.toggle("is-active");
            selection.setAttribute('aria-expanded', `${!open}`);
        });


        dropdown.addEventListener('focusout', (e) => {

            // do nothing if relatedTarget is contained within listboxEl
            if (dropdown.contains(e.relatedTarget)) {
                return;
            }

            closeSelector();
        });

        selector.addEventListener('keydown', (e) => {
            const openKeys = ['ArrowDown', 'ArrowUp', 'Enter', ' '];
            const open = selection.getAttribute('aria-expanded') === 'true';

            if (!open && openKeys.includes(e.key)) {
                openSelector();
            } else if (open && e.key === 'Enter') {
                setSelectorOption(e.target);
                closeSelector();
            } else if (open && e.key === 'Escape') {
                closeSelector();
            }

        });

        dropdown.querySelectorAll("li").forEach((element) => {
            element.addEventListener("click", () => {
                setSelectorOption(element)
                closeSelector();
            });
        });
    }
})();

// PDP Bundle Overlay
(function InitPdpBundleOverlay() {

    // Check for dialogs in the current document
    const dialogs = document.querySelectorAll(".drawer");

    dialogs.forEach(dialog => {

        // Find all elements that control the dialog
        const dialogToggle = document.querySelectorAll("[aria-controls='" + dialog.id + "']");

        const toggleDialog = (e) => {
            e.preventDefault();

            if (dialog.open) {
                dialog.close();
            } else {
                dialog.showModal();
            }
        }

        // Toggle dialog via button click
        dialogToggle.forEach(el => {
            el.addEventListener("click", toggleDialog);
        });

        // Close dialog on backdrop click
        dialog.addEventListener('click', (e) => {
            const contentParent = e.target.closest('.drawer__inner');

            if (e.target && !contentParent && e.target.tagName !== 'BUTTON') {
                dialog.close();
            }
        });
    });

})();

// FAQ
(function IniFaq() {
    const faqs = document.querySelector(".faq-section");

    if (faqs) {
        faqs.querySelectorAll("li.is-faq").forEach((element) => {
            element.addEventListener("click", () => {
                element.classList.toggle("is-active");
            });
        });
    }
})();

// Age consent
(function InitAgeConsent() {
    if (
        window.location.hostname.includes("admin.shopify.com") ||
        window.location.hostname.includes("localhost") ||
        window.location.hostname.includes("online-store-web.shopifyapps.com")
    )
        return;

    // check if cookie consent is set
    const cookieConsent = document.cookie
        .split("; ")
        .find((row) => row.startsWith("age_consent="));

    // Only show age consent if not in Shopify admin domain or else the cookie consent is already set
    if (!cookieConsent) {
        const ageConsentDialog = document.querySelector(".age-consent");
        const ageConsentConfirmButton = ageConsentDialog.querySelector(".age-consent-button[data-action='yes']");
        ageConsentDialog.classList.add('is-active');
        ageConsentConfirmButton.focus();

        ageConsentConfirmButton.addEventListener("click", () => {
                // Set cookie to live for 364 days, secure only
                const expires = new Date();
                expires.setTime(expires.getTime() + 364 * 24 * 60 * 60 * 1000);
                document.cookie =
                    "age_consent=true; expires=" +
                    expires.toUTCString() +
                    "; path=/; Secure";
                ageConsentDialog.classList.remove('is-active');
            });

        document
            .querySelector(".age-consent-button[data-action='no']")
            .addEventListener("click", () => {
                // redirect to https://jokolade.de/
                window.location.href = "https://jokolade.de/";
            });
    }
})();
